import { useTranslations } from 'use-intl';
import { InfoCallout } from '@leanin/ui';
import { ContentProse } from '@/components/prose';

// The resource article's text. The live page and the server-composed body
// (`src/server-render/article-body.tsx`) both render this component, so the
// two produce the same markup: heading levels, linkified URLs, anchors and the
// external-link suffix all come from one place.
export function ArticleBody({ source }: { source: string }) {
  const t = useTranslations('Resources');
  if (source.trim().length === 0) {
    return <InfoCallout tone="neutral">{t('detail.noBody')}</InfoCallout>;
  }
  return <ContentProse source={source} startLevel={2} />;
}
